import { render, staticRenderFns } from "./VsfShippingProvider.vue?vue&type=template&id=3c2e0da4&scoped=true"
import script from "./VsfShippingProvider.vue?vue&type=script&lang=ts"
export * from "./VsfShippingProvider.vue?vue&type=script&lang=ts"
import style0 from "./VsfShippingProvider.vue?vue&type=style&index=0&id=3c2e0da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e0da4",
  null
  
)

export default component.exports